// Age Gate
(function() {
  var gate = document.getElementById('age-gate');
  if (!gate) return;
  if (localStorage.getItem('gc_age_verified') === 'true') {
    gate.style.display = 'none';
    return;
  }
  document.getElementById('age-enter').addEventListener('click', function() {
    localStorage.setItem('gc_age_verified', 'true');
    gate.style.display = 'none';
  });
  document.getElementById('age-leave').addEventListener('click', function() {
    window.location.href = 'https://www.google.com';
  });
})();

// Cart count update
document.addEventListener('DOMContentLoaded', function() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(function(cart) {
      var el = document.getElementById('cart-count');
      if (el) el.textContent = '(' + cart.item_count + ')';
    });
});
